import { SelectionChangedEvent } from "ag-grid-community";
import { ChargeOnCompanyMappingEntity } from "domain/entity/ChargeOnCompanyMapping/ChargeOnCompanyMappingEntity";
import _ from "lodash";
import { INITIAL_CHARGE_ON_COMPANY_MAPPING_COL_DEF } from "presentation/constant/ChargeOnCompanyMapping/ChargeOnCompanyMappingColumnDefinition";
import { ChargeOnCompanyMappingConstant } from "presentation/constant/ChargeOnCompanyMapping/ChargeOnCompanyMappingConstant";
import { useChargeOnCompanyMappingVM } from "presentation/hook/ChargeOnCompanyMapping/useChargeOnCompanyMappingVM";
import { useMessageBarVM } from "presentation/hook/useMessageBar";
import { useANAInfoTracked } from "presentation/store/ANAInfo";
import { useChargeOnCompanyMappingTracked } from "presentation/store/ChargeOnCompanyMapping/ChargeOnCompanyMappingProvider";
import RightClickMenuWithMoveAfter from "presentation/view/components/NbisRightClickMenu/RightClickMenuWithMoveAfter";
import NbisTable from "presentation/view/components/TableWrapper/NbisTable";
import { TableWrapper } from "presentation/view/components/TableWrapper/TableWrapper";
import { createRef, memo, useCallback, useEffect, useMemo, useRef, useState } from "react";
import { Loader } from "veronica-ui-component/dist/component/core";
const ChargeOnCompanyMappingTablePanel = () => {
    const gridRef: any = useRef(null);
    const [chargeOnCompanyMappingState] = useChargeOnCompanyMappingTracked();
    // const {chargeOnCompanyMappingList,updatedRows} = chargeOnCompanyMappingState;
    const chargeOnCompanyMappingVM = useChargeOnCompanyMappingVM();
    const messageBarVM = useMessageBarVM();

    // const [onTableSelectionClicked, setOnTableSelectionClicked] = useState<boolean>(false);
    const [anainfoState] = useANAInfoTracked();
    const { allowUpdate, allowCreate } = anainfoState;
    const rightClickRef: any = createRef();
    // for right click menu with move after begin
    const [showMoveCursor, setShowMoveCursor] = useState<boolean>(false);
    const [allRows, setAllRows] = useState<ChargeOnCompanyMappingEntity[]>([]);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [initialAllRows, setInitialAllRows] = useState<boolean>(true);

    const getAllRows = useCallback(() => {
        return allRows;
    }, [allRows]);

    const getSelectedRows = useCallback(() => {
        return chargeOnCompanyMappingState.selectedRows;
    }, [chargeOnCompanyMappingState.selectedRows]);

    // const getShowMoveCursor = useCallback(() => {
    //     return showMoveCursor;
    // }, [showMoveCursor]);
    // //for right click menu with move after end

    // useEffect(() => {
    //     //const columnDefs = (INITIAL_CHARGE_ON_COMPANY_MAPPING_COL_DEF?.slice());

    //     if (!chargeOnCompanyMappingState.selectedRows || chargeOnCompanyMappingState.selectedRows.length <= 0) {
    //         //gridRef.current?.gridRef.current.api?.setColumnDefs(columnDefs);
    //         if (!onTableSelectionClicked) {
    //             gridRef.current?.gridRef.current.api?.deselectAll();
    //         }
    //     }
    //     changeCursor("charge-on-company-mapping-table", getShowMoveCursor());
    // });

    // useEffect(() => {
    //     if (!onTableSelectionClicked) return;
    //     gridRef?.current?.gridRef.current.api?.deselectAll();
    //     changeCursor("charge-on-company-mapping-table", getShowMoveCursor());
    // }, [getShowMoveCursor, onTableSelectionClicked]);




    const handleSelectionChange = useCallback((e: SelectionChangedEvent) => {
        const selectedRows = e.api.getSelectedRows();
        // setOnTableSelectionClicked(true);
        chargeOnCompanyMappingVM.updateSelectedRows(selectedRows);
    }, [chargeOnCompanyMappingVM])

    // const handleRowDrag = useCallback( (e: any, updatedRows: ChargeOnCompanyMappingEntity[], movedIndex: number, overIndex: number)=>{
    //     chargeOnCompanyMappingVM.onRowDrag(updatedRows);
    // },[chargeOnCompanyMappingVM])

    const handleRowDoubleClick = useCallback((entity: ChargeOnCompanyMappingEntity) => {
        // if(updatedRows.length > 0){
        //     messageBarVM.showError("Modified data has not been saved.Please save or refersh the data first."); 
        //     return;
        // }
        chargeOnCompanyMappingVM.onRowDoubleClick(entity);
    }, [chargeOnCompanyMappingVM])

    useEffect(() => {
        const handleRightClickMenu = (event: any) => {
            if (_.isEmpty(chargeOnCompanyMappingState.selectedRows) || !allowUpdate) {
                return;
            }
            event.preventDefault();
            rightClickRef.current.show(event);
        };
        document.getElementById('myDiv')?.addEventListener("contextmenu", handleRightClickMenu);

        return () => {
            document.getElementById('myDiv')?.removeEventListener("contextmenu", handleRightClickMenu);
        };
    }, [messageBarVM, rightClickRef, allowUpdate, chargeOnCompanyMappingState.selectedRows]);

    // for right click menu with move after begin
    const onRefreshRow = useCallback((newAllRows: any[]) => {
        setAllRows(newAllRows);
        chargeOnCompanyMappingVM.updateSelectedRows([]);
        setShowMoveCursor(true);
    }, [chargeOnCompanyMappingVM]);

    const onMoveCancel = useCallback(() => {
        setInitialAllRows(true);
        setAllRows(chargeOnCompanyMappingState.chargeOnCompanyMappingList);
        chargeOnCompanyMappingVM.updateSelectedRows([]);
        setShowMoveCursor(false);
    }, [chargeOnCompanyMappingState.chargeOnCompanyMappingList, chargeOnCompanyMappingVM]);

    const onSaveMove = useCallback(async (newAllRows: any[]) => {
        if (_.isEmpty(newAllRows)) return;

        setIsLoading(true);

        chargeOnCompanyMappingVM.onApply(newAllRows).then((res) => {
            if (!res || !res.success) {
                messageBarVM.showError('Move failed.');
                setInitialAllRows(true);
                setIsLoading(false);

                chargeOnCompanyMappingVM.updateSelectedRows([]);
                setShowMoveCursor(false);
            } else {
                chargeOnCompanyMappingVM.searchAllChargeOnCompanyMappingList().then((data) => {
                    setInitialAllRows(true);
                    setIsLoading(false);

                    chargeOnCompanyMappingVM.updateSelectedRows([]);
                    setShowMoveCursor(false);
                }).catch((e) => {
                    setInitialAllRows(true);
                    setIsLoading(false);

                    chargeOnCompanyMappingVM.updateSelectedRows([]);
                    setShowMoveCursor(false);
                })
            }
        })
    }, [messageBarVM, chargeOnCompanyMappingVM]);

    const handleAddClick = useCallback(() => {
        chargeOnCompanyMappingVM.onAddClick();
    }, [chargeOnCompanyMappingVM]);


    const memoChargeOnCompanyMappingTable = useMemo(() => {

        return (
            <>
                {(allowUpdate) && <RightClickMenuWithMoveAfter disabled={_.isEmpty(getSelectedRows())}
                    rightClickRef={rightClickRef} selectedRows={getSelectedRows()} allRows={getAllRows()}
                    onSaveMove={onSaveMove} onCancel={onMoveCancel} onRefreshRow={onRefreshRow}
                    showConfirmMove={showMoveCursor} priorityName="priority" />}
                <div id="myDiv">
                    <NbisTable
                        id='charge-on-company-mapping-table'
                        isNewColumnSetting={true}
                        headerLabel={ChargeOnCompanyMappingConstant.Title.TITLE}
                        columns={INITIAL_CHARGE_ON_COMPANY_MAPPING_COL_DEF}
                        data={allRows ?? []}
                        showPaginator={false}
                        editable={false}
                        showAddIcon={allowCreate}
                        showDeleteButton={false}
                        showReloadIcon={false}
                        isScrollHighlighted={true}
                        selectionMode={false}
                        isRowHighligted={true}
                        handleSelectionChanged={handleSelectionChange}
                        // onRowClick={(e: any) => handleRowClick(e.data)}
                        onRowDoubleClick={(e: any, entity: ChargeOnCompanyMappingEntity) => handleRowDoubleClick(entity)}
                        gridHeight="customHeight"
                        customHeight="calc(100vh - 75px)"
                        ref={gridRef}
                        // isRowDrag={true}
                        // onRowDragged={handleRowDrag}
                        rowSelection={showMoveCursor ? "single" : "multiple"}
                        // onBodyScroll={(e: any) => changeCursor("charge-on-company-mapping-table", getShowMoveCursor())}
                        onAddClick={handleAddClick}
                        showCutCursor={showMoveCursor}
                    />
                </div>
            </>
        );
    }, [allowCreate, allRows, allowUpdate, getAllRows, getSelectedRows, handleRowDoubleClick, handleSelectionChange, onMoveCancel, onRefreshRow, onSaveMove, rightClickRef, showMoveCursor, handleAddClick])

    useEffect(() => {
        if (initialAllRows && chargeOnCompanyMappingState.chargeOnCompanyMappingList && !_.isEmpty(chargeOnCompanyMappingState.chargeOnCompanyMappingList)) {
            setAllRows(chargeOnCompanyMappingState.chargeOnCompanyMappingList.map((chargeOnCompanyMappingEntity, index) => ({
                ...chargeOnCompanyMappingEntity,
                index: index || 0
            })));
            setInitialAllRows(false);
        }
    }, [allRows, initialAllRows, chargeOnCompanyMappingState.chargeOnCompanyMappingList]);

    return <><TableWrapper>
        {(isLoading) && <Loader Indicator="Spinner" size="Medium" />}
        {memoChargeOnCompanyMappingTable}
        {chargeOnCompanyMappingState.forceRefresh && <></>}
    </TableWrapper>
    </>;
}

export default memo(ChargeOnCompanyMappingTablePanel);
